export const moduleTypes = [
  {
    value: 'all',
    label: 'All'
  },
  {
    value: 'issues',
    label: 'Issues'
  },
  {
    value: 'forms',
    label: 'Form'
  },
  {
    value: 'rfis',
    label: 'RFIs'
  },
  {
    value: 'submittals',
    label: 'Submittals'
  },
  {
    value: 'files',
    label: 'Files'
  },
  {
    value: 'excel',
    label: 'Excel'
  },
  {
    value: 'ets',
    label: 'ETS'
  },
  {
    value: 'Concrete Cube Test',
    label: 'Concrete Cube Test'
  },
  {
    value: 'spreadsheets',
    label: 'Spreadsheets'
  }
];

export const dataElement = [
  { name: 'Lift Datahub', id: 'lift_datahub' },
  { name: 'Piling Installation Record', id: 'piling_installation_record' },
  { name: 'Ultimate Load Test', id: 'ultimate_load_test' },
  { name: 'Working Load Test', id: 'working_load_test' },
  { name: 'Concrete Cube Test Contractor', id: 'concrete_cube_test_contractor' },
  { name: 'Concrete Cube Test Laboratory', id: 'concrete_cube_test_laboratory' },
  { name: 'Steel Element Test', id: 'steel_element_test' },
  { name: 'Steel Rebar Test', id: 'steel_rebar_test' },
  { name: 'Site Progress', id: 'site_progress' },
  { name: 'Qualified Person Site Supervisor Attendance', id: 'qualified_person_site_supervisor_attendance' },
  { name: 'Manpower Utilization', id: 'manpower_utilization' },
  { name: 'Manpower Distribution', id: 'manpower_distribution' }
];

export const renderLabelProvider = {
  redas: 'Redas',
  sgbuildex: 'SGBuildex',
  autodesk: 'Autodesk',
  googledrive: 'Google Drive'
};

export function transformMetadata(data) {
  const receives = data.metadata?.receives;
  const identityName = data.metadata?.data?.identity.name;
 
  // helper to convert snake_case → Title Case
  const formatName = (str) =>
    str
      .split('_')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  console.log({receives, identityName, data});
  return Object.keys(receives || {}).filter((key) => receives[key] === true)?.map((key) => (
    {
      connection_id: data.id,
      img: data.img,
      label: data.label,
      name: identityName,
      isActive: true,
      element_id: key,
      element_name: formatName(key)
    }
  )) || []
}

const TOKEN_KEY = 'remaining_token';

export const getRefreshTokenPBI = () => {
  return Number(localStorage.getItem(TOKEN_KEY)) || 8;
};

export const setRefreshTokenPBI = (value) => {
  localStorage.setItem(TOKEN_KEY, value);
};
